export const name = 'Gepax Platform';
export const url = 'gepax.us';

export default {name,url};